import StoredLayout from '../../layouts/StoredLayout'
import ProgressBars from './ProgressBars'
export default StoredLayout(ProgressBars)



// WEBPACK FOOTER //
// ./src/ui-elements/progress-bars/index.js